<template>
    <div id="invite_detail">
        <div class="bread">
            <el-breadcrumb >
                <el-breadcrumb-item :to="{path: '/course_list',query:{type:type}}">直播列表</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path: '/course',query:{liveId:livingId,type:type,livetype:livetype}}">
                    组别数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})
                </el-breadcrumb-item>
                <el-breadcrumb-item>组内数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="back" @click="backPage()"> 返回</div>
        </div>
        <div class="main">
            <div class="courselist-box">
                <div class="titlebox">
                    <div class="title">组内数据({{ livetype=="all"?"全部":livetype=="replay"?"回放":"直播" }})</div>
                    <div class="notice">
                        <!-- <dlxlsx :sheet="line.down.sheet" :head="line.down.head" :data="line.down.list"></dlxlsx> -->
                        <dlxlsx :livingId="livingId" :bmbm="bmbm" :livetype="livetype"></dlxlsx>
                        <span class="refresh" @click="getList">刷新</span>
                    </div>
                </div>
                <div class="string"></div>
                <div class="navs">
                    <el-form class="course_search_form" ref="course_search_form" size="large">
                        <el-form-item v-if="type || type!=''" label="资源进线时间">
                            <el-date-picker v-model="date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="getList" format="YYYY-MM-DD" value-format="YYYY-MM-DD">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="MCN列表:" style="margin-left: 32px;" v-if="type=='_1'">
                            <el-select clearable v-model="search.mcnName" @clear="mcnClear" @change="mcnChange">
                                <el-option v-for="(item, index) in mcn" :key="index" :label="item.mcn_name" :value="item.mcn_name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="老师:" style="margin-left: 32px;" v-if="type=='_1'">
                            <el-select clearable v-model="search.teacherId" @clear="teacherClear" @change="teacherChange">
                                <el-option v-for="(item, index) in teacher" :key="index" :label="item.refferid_name" :value="item.refferid"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item style="margin-left: 32px;color:red;" v-if="type=='_1'">
                            <span>{{seltxt}}</span>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="list">
                    <!--  -->
                    <el-table :height="tableHeight" v-loading="loading" element-loading-text="查找数据可能会花费较长时间，请耐心等待..." :data="tableData" style="width: 98%;margin: 0 auto;height: 100%;overflow: auto;" :header-cell-style="{backgroundColor: '#FAFAFA'}" :row-style="{height: '40px'}" :cell-style="{padding: '0'}">
                        <el-table-column label="序号" width="100" align="center" fixed="left">
                            <template #default="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="业务员" prop="yhmc" align="left" fixed="left" min-width="140">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row)">{{scope.row.yhmc}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="听课ip数" prop="account_num" align="left" width="300">
                            <template #default="scope">
                                <div style="display: flex;">
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>③</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num3}}</span>
                                    </div>
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>②</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num2}}</span>
                                    </div>
                                    <div v-if="!type || type==''" class="ipNum">
                                        <span>①</span>
                                        <span style="margin-left: 6px;">{{scope.row.account_num1}}</span>
                                    </div>
                                    <div class="ipNum">
                                        <span v-if="!type || type==''">/</span>
                                        <span style="margin-left: 6px;font-weight: bold;">{{scope.row.account_num}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>

                        <template v-if="type==''">
                            <el-table-column label="最大听课IP数" sortable prop="account_num4" align="center" width="140">
                                <template #default="scope">
                                    <span>{{scope.row.account_num4}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="新客户数" sortable prop="user_x" align="center" width="100">
                                <template #default="scope">
                                    <span v-if="scope.row.user_x>0" :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, 51)">{{scope.row.user_x}}</span>
                                    <span v-else>{{scope.row.user_x}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="老客户数" sortable prop="user_old" align="center" width="100">
                                <template #default="scope">
                                    <span v-if="scope.row.user_old>0" :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, 52)">{{scope.row.user_old}}</span>
                                    <span v-else>{{scope.row.user_old}}</span>
                                </template>
                            </el-table-column>
                        </template>

                        <el-table-column label="退出人数" sortable prop="out_num" align="center" width="100">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, -1)">{{scope.row.out_num}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="10分钟以下" prop="10time" align="center" width="140">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, 10)">{{scope.row['10time']}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="10～29分钟" prop="23time" align="center" width="140">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, 23)">{{scope.row['23time']}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column sortable label="30分钟及以上" prop="30time" align="center" width="140">
                            <template #default="scope">
                                <span :class="dynamicStyle(scope.row)" @click="gotoPage(scope.row, 30)">{{scope.row['30time']}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="30分钟及以上占比" align="center" width="140">
                            <template #default="scope">
                                <span style="font-weight: bold;" v-if="scope.row.account_num == 0">0.00%</span>
                                <span style="font-weight: bold;" v-else>{{(scope.row['30time'] / scope.row.account_num*100).toFixed(2)}}%</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './assets/less/index.less'
import model from './model/model'
import common_m from '@/common/model'
import dlxlsx from '@/components/dlXlsx_ci/index'

var that = null
export default {
    components: {
        dlxlsx,
    },
    data() {
        that = this
        return {
            loading: true,
            type: that.$route.query.type || '', //部门类型
            livetype: that.$route.query.livetype || '', //直播数据类型
            navIndex: 0,
            userInfo: null,
            tableHeight: 500,
            tableData: [],
            media_list: [], // 媒体列表
            activeIndex: 0,
            livingId: that.$route.query.liveId || '0', //标题
            bmbm: that.$route.query.bmbm || '', //标题
            currentUserInfo: null,
            date: JSON.parse(that.$route.query.date) || null, //标题
            search: {
                mcnName: null,
                teacherId: null,
            },
            mcn: [],
            teacher: [],
            seltxt: '',
        }
    },
    mounted() {
        // 初始化前判断登录态缓存，不存在则跳回列表页
        if (!localStorage.getItem('fallback_ywy_user')) {
            that.$router.replace('/course_list')
            return
        }
        that.$nextTick(() => {
            that.tableHeight = document.querySelector('.list').clientHeight - 80
        })
        that.init()
    },
    methods: {
        init() {
            if (that.userInfo != '') {
                // console.log('JSON=', that.userInfo)
                that.userInfo = JSON.parse(that.userInfo)
            }
            that.getList()
            that.getUserInfo()
            if (that.type == '_1') {
                that.getMCN(1)
            }
        },
        getUserInfo() {
            common_m.getUserInfo().then(
                function (res) {
                    that.currentUserInfo = res
                    
                },
                function (err) {
                    console.log(err)
                    that.loading = false
                    that.currentUserInfo = {}
                    // that.getList()
                }
            )
        },
        dynamicStyle(item) {
            let className = null
            // console.log(item.yhmc)

            if (that.currentUserInfo.yhid == item.yhid) {
                className = 'caozuo'
            } else {
                // if (that.currentUserInfo.zwbm != 331)
                className = 'caozuo'
                // else
                //   className = ''
            }
            return className
        },
        backPage() {
            window.history.back()
        },
        getList() {
            that.seltxt = ''
            that.loading = true
            let params = {
                livingid: that.livingId,
                bmbm: that.bmbm,
                type: 2,
                pageIndex: 1,
                pageSize: 50,
            }
            if (that.type && that.type != '' && that.date != '') {
                params.begintime = that.date[0]
                params.endtime = that.date[1]
            }
            if (that.type == '_1') {
                if (that.search.teacherId != null) {
                    params.refferid = that.search.teacherId
                }
            }
            let bmbm =
                that.currentUserInfo && that.currentUserInfo.bmbm
                    ? that.currentUserInfo.bmbm
                    : ''
            model.get_e_live_bm(params, that.type, that.livetype, bmbm).then(
                function (res) {
                    that.loading = false
                    if (res.code == 0) {
                        // let list = res.list
                        // let new_item = {
                        //   account_num: list.reduce((sum, item) => sum + item.account_num, 0),
                        //   '10time': list.reduce((sum, item) => sum + item['10time'], 0),
                        //   '23time': list.reduce((sum, item) => sum + item['23time'], 0),
                        //   '30time': list.reduce((sum, item) => sum + item['30time'], 0),
                        //   e_id:"",
                        //   yhmc: "合计"
                        // }
                        // list.unshift(new_item);
                        that.tableData = res.list
                        // that.page.total = res.total;
                    } else {
                        that.tableData = []
                    }
                },
                function (err) {
                    console.log(err)
                    that.loading = false
                    that.tableData = []
                }
            )
        },

        /**
         * 获取MCN列表
         */
        getMCN(id) {
            model.getMCN(id).then((res) => {
                if (res.code == 0) {
                    that.mcn = res.data
                }
            })
        },

        /**
         * MCN清空处理
         */
        mcnClear() {
            that.loading = true
            that.search.mcnName = null
            that.search.teacherId = null
            that.getList()
        },

        /**
         * MCN变化处理
         */
        mcnChange() {
            if (that.search.mcnName) {
                that.search.teacherId = null
                that.teacher = []
                that.getTeacher(that.search.mcnName)
            }
        },

        /**
         * 获取老师列表
         */
        getTeacher(name) {
            model.getTeacher(name).then((res) => {
                if (res.code == 0) {
                    that.teacher = res.data
                }
            })
        },

        /**
         * 老师清空处理
         */
        teacherClear() {
            that.loading = true
            that.search.teacherId = null
            that.getList()
        },

        /**
         * 老师变化处理
         */
        teacherChange() {
            // 判断是否有选择时间
            if (that.date == null) {
                that.seltxt = 'mcn搜索需要选择时间'
            } else {
                that.getList()
            }
        },

        handleChange(index) {
            if (that.loading) {
                return
            }
            that.navIndex = index
            that.getList()
        },

        gotoPage(item, type) {
            let params = '&date=' + JSON.stringify(that.date)
            if (type) params += '&type=' + type
            if (that.type && that.type != '') params += '&bm_type=' + that.type
            if (that.currentUserInfo.yhid == item.yhid) {
                let url = '/course_info'
                url += '?liveId=' + that.livingId
                url += '&bmbm=' + that.bmbm
                url += '&e_id=' + item.e_id
                url += '&livetype=' + that.livetype
                url += params
                window.location.href = url
            } else {
                // if (that.currentUserInfo.zwbm != 331) {
                let url = '/course_info'
                url += '?liveId=' + that.livingId
                url += '&bmbm=' + that.bmbm
                url += '&e_id=' + item.e_id
                url += '&livetype=' + that.livetype
                url += params
                window.location.href = url
                //}
            }
        },
    },
}
</script>
